<div class="discount-package-container mat-elevation-z8">
  <div class="header">
    <div class="title">
      <span> بسته {{ discountType.name }} </span>
    </div>
    <div class="body">
      <br />
      <div class="price" *ngIf="!preview">
        <h1>
          {{ withCommas(discountType.price) | digitsEnToFa }}
          <span class="toman">تومان</span>
        </h1>
        <span class="single-page-price"
          >قیمت هر برگ {{ displayPriceOneSingle() | digitsEnToFa }} تومان</span
        >
      </div>
    </div>
  </div>

  <div class="card-body">
    <div class="info">
      <mat-nav-list class="item-lists">
        <a mat-list-item>
          <div
            fxLayout="row"
            fxLayoutAlign="space-between center"
            style="width: 100%"
          >
            <span>حجم بسته‌: </span>
            <span>
              {{ withCommas(discountType.pages) | digitsEnToFa }} برگ</span
            >
          </div>
        </a>
        <a mat-list-item>
          <div
            fxLayout="row"
            fxLayoutAlign="space-between center"
            style="width: 100%"
          >
            <span>زمان بسته: </span>
            <span> {{ sayDays() | digitsEnToFa }} روز</span>
          </div>
        </a>
        <a mat-list-item *ngIf="discount">
          <div
            fxLayout="row"
            fxLayoutAlign="space-between center"
            style="width: 100%"
          >
            <span>مهلت باقیمانده: </span>
            <span *ngIf="sayRemainingDays() > 0"> {{ sayRemainingDays() | digitsEnToFa    }} روز</span>
            <span *ngIf="sayRemainingDays() <= 0"> {{   0  }} روز</span>
            <!-- <span> {{discount.remainTime| digitsEnToFa }} روز</span> -->
          </div>
        </a>
      </mat-nav-list>
    </div>

    <div
      class="actions"
      *ngIf="!preview"
      fxLayout="row"
      fxLayoutAlign="center center"
    >
      <button mat-button (click)="buyThis()" color="primary">
        خرید و فعال سازی
      </button>
    </div>
  </div>
</div>
